import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig } from 'lib/react-query';

import { WeatherWall } from 'types';

export const shareWeatherWall = ({
  wallId,
  userId,
  saveOverWeatherWall,
}: {
  wallId: number;
  userId: number;
  saveOverWeatherWall: number;
}): Promise<WeatherWall> => {
  return axios.put(
    `/api/weather/walls/${wallId}/users/${userId}/share/${saveOverWeatherWall}`
  );
};

type UseShareWeatherWallOptions = {
  config?: MutationConfig<typeof shareWeatherWall>;
};

export const useShareWeatherWall = ({
  config,
}: UseShareWeatherWallOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: shareWeatherWall,
  });
};
